import { Inject, OnDestroy } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../app.state';
import { toggleOutlines } from '../../../visual/visual.actions';

@Component({
  selector: 'nns-outline',
  host: {
    '[class]': 'classNames'
  },
  styles: [`
    :host{
      display: block;
      max-height: 100%;
      width: 230px;
      box-sizing: border-box;
      bottom: 0;
      background-color: #fff;
      overflow: hidden;
    }
    :host.nns-outlines-floating{
      position: fixed;
      top: 60px;
    }
    :host.nns-outlines-floating .nns-outline-wrapper{
      padding-top: 20px;
    }
    .nns-outline-wrapper{
      border-left: 1px solid #E8E8E8;
      padding-left: 20px;
      height: 100%;
      overflow: hidden;
      overflow-y: auto;
      padding-right: 35px;
      margin-right: -30px;
      padding-bottom: 20px;
      box-sizing: border-box;
    }

    .nns-outline-wrapper:hover{
      padding-right: 5px;
      margin-right: 0;
    }

    :host:not(.nns-outline-single) .nns-outline-wrapper,
    :host:not(.nns-outline-floating) .nns-outline-wrapper,
    {
      border: 1px solid #E8E8E8;
      height: auto;
      padding: 20px;
    }
    :host.nns-fullscreen.nns-outlines-floating{
      top: 0;
    }

    .nns-outline-close{
      position: absolute;
      top: 0;
      left: 5px;
      cursor: pointer;
      display: none;
    }
    .nns-outline-close nns-icon{
      min-width: 16px;
      min-height: 16px;
    }

    nns-outline-item:not(:first-child) {
      margin-top: 8px;
    }

    @media (max-width: 1200px) {
      :host{
        padding-top: 26px;
      }
      :host.nns-outlines-floating{
        top: 0;
        position: relative;
      }
      .nns-outline-close{
        display: block;
      }
      :host{
        position: fixed!important;
        top: 57px!important;
        border-left: 1px solid #E8E8E8;
        right: 0;
      }
      :host .nns-outline-wrapper{
        border: none!important;
        padding-top: 0;
      }
    }
  `, `
    :host-context(.nns-theme-night) .nns-outline-wrapper{
      border-color: rgba(255,255,255,0.12);
    }
    :host-context(.nns-theme-night){
      background-color: #20252B;
      border-color: rgba(255,255,255,0.12);
    }
  `],
  template: `
    <div class="nns-outline-wrapper">
      <div class="nns-outline-close" (click)="onClose()">
        <nns-icon icon="close"></nns-icon>
      </div>
      <div class="nns-outline-list">
        <nns-outline-item
          *ngFor="let outline of outlines"
          [item]="outline"
        ></nns-outline-item>
      </div>
    </div>
  `
})
export class OutlineComponent implements OnInit, OnDestroy{
  @Input() outlines;
  @Input() isFullScreen;
  @Input() isSingle;
  classNames: string;
  isFloating: boolean;
  scrollTopFloating: number;
  appElement;
  outlineWrapper;
  eventListener;
  scrollEventListener;
  scrollTop;

  constructor(
    private _store: Store<IAppState>,
    @Inject('isBrowser') public isBrowser: boolean,
  ) { }

  ngOnInit() {
    if(this.isBrowser) {
      this.appElement = document.getElementsByTagName('nns-app')[0];
      this.outlineWrapper = document.getElementById('nns-outline-wrapper');
      this.appElement.addEventListener('scroll', scrollEventListener)
    }
    const _this = this;
    function scrollEventListener(event) {
      const target:any  = event.target;
      const scrollTop = target.scrollTop;
      _this.scrollTop = scrollTop;
      if(_this.isSingle && _this.isFullScreen && _this.isFloating) {
        return;
      }


      _this.scrollTopFloating = _this.outlineWrapper.offsetTop;
      if(scrollTop > _this.scrollTopFloating) {
        if(!_this.isFloating) {
          _this.isFloating = true;
          _this.setClassNames();
        }
      }

      if(scrollTop < _this.scrollTopFloating) {
        _this.isFloating = false;
        _this.setClassNames();
      }
    }
    this.scrollEventListener = scrollEventListener;
  }



  ngOnChanges(changes) {
    if(changes.isSingle || changes.isFullScreen) {
      if(this.isSingle && this.isFullScreen && !this.isFloating) {
        this.isFloating = true;
      }
      if(this.isSingle && !this.isFullScreen && this.isFloating && (!this.scrollTop || this.scrollTop < 80)) {
        this.isFloating = false;
      }
      this.setClassNames();
    }
  }

  setClassNames() {
    let classNames = '';
    if(this.isFloating) classNames = 'nns-outlines-floating';
    if(this.isFullScreen) classNames += ' nns-fullscreen';
    if(this.isSingle) classNames += ' nns-outline-single';
    this.classNames = classNames;
  }

  onClose()  {
    this._store.dispatch(toggleOutlines());
  }

  ngOnDestroy() {
    this.appElement.removeEventListener('scroll', this.scrollEventListener);
  }
}
